export default "__VITE_ASSET__SLWcxkZx__"